import coursesData from './data/courses.json';
import categoriesData from './data/categories.json';

// Use raw JSON data without validation
export const mockCourses: any[] = coursesData;

// Use raw JSON data without validation
export const categories: any[] = categoriesData;

// Export a generic type
export type Course = any; 